module.exports = __webpack_public_path__ + "static/img/4.8be8d97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/4.png
// module id = cJKB
// module chunks = 0